var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Menu',{ref:"menu",attrs:{"active-name":_vm.active,"open-names":_vm.open,"width":"auto","accordion":""}},[_c('MainMenu',{attrs:{"update":_vm.update}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }